function ChevronDown() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25105 5.25105C2.58579 4.91632 3.1285 4.91632 3.46323 5.25105L8 9.78782L12.5368 5.25105C12.8715 4.91632 13.4142 4.91632 13.749 5.25105C14.0837 5.58579 14.0837 6.1285 13.749 6.46323L8.60609 11.6061C8.27136 11.9408 7.72865 11.9408 7.39391 11.6061L2.25105 6.46323C1.91632 6.1285 1.91632 5.58579 2.25105 5.25105Z"
        fill="#7953D2"
      />
    </svg>
  );
}

export default ChevronDown;
